import BlockContainer from './BlockContainer';

export default BlockContainer;
